import {request} from '/app/src/lib';
import {store, history } from '/app/src/store';
import Model from '../model';
import * as actions from './actions';

class DiscountCode extends Model {

    get(){
        let url = this.url();
        this._success = (dispatch, err, res) => {
            const discounts = res.body.discount.discounts;
            dispatch(actions.discountFetchSuccesfully(discounts));
        }

        return (dispatch) => {
            const token = this.token()
            request
            .post(`${url}/admin/discounts/read`)
            .accept('application/json')
            .send({})
            .set('Authorization', 'Bearer ' + token)
            .end(this.handleResponse(dispatch));
        }
    }
    create(code, description, type, specification, startDate, expiryDate, numberOfUses){
        let url = this.url();
        this._success = (dispatch, err, res) => {
            const discounts = res.body.discounts;
            dispatch(actions.discountFetchSuccesfully(discounts));
        }

        return (dispatch) => {
            const token = this.token()
            request
            .post(`${url}/admin/discount/create`)
            .accept('application/json')
            .send({
                code: code,
                description: description,
                type: type,
                specification: specification,
                start_date: startDate,
                expiry_date: expiryDate,
                number_of_uses: numberOfUses
            })
            .set('Authorization', 'Bearer ' + token)
            .end(this.handleResponse(dispatch));
        }
    }
}

export default new DiscountCode();



// WEBPACK FOOTER //
// src/model/DiscountCode/model.js